import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";
import VotifyPlaybackControl from "../VotifyPlayback/VotifyPlaybackControl";
import VotifySharePartyModal from "./VotifySharePartyModal";

const MainTopMenu = ({ partyUrl, isHost }) => (
  <div style={style.main}>
    {(isHost && (
      <VotifyPlaybackControl
        icon={
          <Icon
            style={style.qrCodeIcon}
            name={"ellipsis vertical"}
            size={"big"}
          />
        }
      />
    )) || <div></div>}
    <VotifySharePartyModal
      trigger={
        <Icon style={style.qrCodeIcon} name={"share alternate"} size={"big"} />
      }
      partyUrl={partyUrl}
    />
  </div>
);

MainTopMenu.propTypes = {
  partyUrl: PropTypes.string.isRequired,
  isHost: PropTypes.bool.isRequired,
};

const style = {
  main: {
    width: "100%",
    position: "absolute",
    opacity: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  qrCodeIcon: { color: "rgba(128, 128, 128, 0.5)", margin: "1rem" },
  qrCode: {
    margin: "auto",
    left: 0,
    right: 0,
  },
  modal: {
    paddingTop: "160px",
  },
};

export default MainTopMenu;
